export const ASSET_LOCATION_OVERRIDE_SESSION_STORAGE_KEY = "md.wcbootstrap.assetLocation";